import feather from 'feather-icons'
import { domReady } from '../utils'

const initFeather = () => feather.replace()

export default domReady(initFeather)